<template>
  <div class="row">
    <div class="input-field col s12">
      <textarea
        id="address"
        class="materialize-textarea"
        v-model="address"
        @keyup="search"
        autocomplete="off"
      ></textarea>
      <label for="address" v-bind:class="{ active: address }">Adresse de livraison</label>
      <ul>
        <proposal-addresses
          v-for="item in proposalAddress"
          v-bind:title="item.properties.label"
          v-bind:key="item.properties.label"
          @select="address = $event; proposalAddress = []"
        ></proposal-addresses>
      </ul>
    </div>
  </div>
</template>

<script>
import ProposalAddresses from "@/components/Basket/ProposalAddresses.vue";
import axios from 'axios';

export default {
  data: function() {
    return {
      proposalAddress: []
    };
  },
  computed: {
    address: {
      get() {
        return this.$store.state.address;
      },
      set(value) {
        this.$store.commit("updateAddress", value);
      }
    }
  },
  methods: {
    search: function() {
      // Défini this, pour être utiliser au sein du callback .then
      const vm = this;
      if (this.address.length > 2) {
        var searchAddress = this.address.split(" ").join("+");
        axios
          .get("https://api-adresse.data.gouv.fr/search/?q=" + searchAddress)
          .then(function(response) {
            vm.proposalAddress = response.data.features;
          });
      }
    }
  },
  components: { ProposalAddresses }
};
</script>